import { Box } from '@mui/material';
import { Heading, Text } from '../atomic';

/**
 * Introduction section for the collaborate page
 *
 * @returns {JSX.Element} Introduction section component
 */
function IntroductionSection() {
  return (
    <Box sx={{ mb: 8, textAlign: 'center' }}>
      <Heading variant="h2" sx={{ mb: 3, fontSize: '2rem', fontWeight: 600 }}>
        Transform Healthcare Together
      </Heading>
      <Text
        sx={{
          fontSize: '1.125rem',
          lineHeight: 1.7,
          maxWidth: '800px',
          mx: 'auto',
        }}
      >
        Whether you're a healthcare organization seeking transformation, a
        consultant looking to join our network, or an innovator with
        groundbreaking ideas, RSM Collective is your partner in revolutionizing
        healthcare delivery through technology.
      </Text>
    </Box>
  );
}

export default IntroductionSection;
